// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  position: relative;
  height: 48px;
}

.dropdown-textbox {
  display: flex;
  min-width: 240px;
  height: 48px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--Spacings-Spacing-01, 4px);
}

:host(.compact) .dropdown-textbox {
  min-width: clamp(160px, 18vw, 240px);
}
.dropdown-textbox-content {
  display: flex;
  height: 40px;
  padding: var(--Spacings-Spacing-01, 4px) var(--Spacings-Spacing-03, 12px);
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  align-self: stretch;
  border-radius: 16px;
  border: 1px solid var(--Colors-UI-Secondary-Secondary-Light, #CCDCE4);
  background: var(--Colors-UI-Neutral-Grey-0, #FFF);
  cursor: pointer;
}
.dropdown-textbox-content:hover {
  background: #F0F4F8;
}
.dropdown-textbox-content:active {
  background: #E0E8F0;
}
.dropdown-textbox-inner {
  display: flex;
  padding: 0 var(--Spacings-Spacing-02, 8px);
  align-items: center;
  justify-content: space-between;
  flex: 1 0 0;
  user-select: none;
}
.dropdown-textbox-title {
  color: var(--Colors-UI-Status-Information-Information-Dark, #023650);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  white-space: nowrap;
  user-select: none;
}
.dropdown-textbox-title.placeholder {
  font-weight: 400;
}

.dropdown-main-container {
  z-index: 50;
  display: none;
  align-items: center;
  justify-content: center;
  background-color: #f9fafb;
  position: absolute;
  top: 100%;
  left: 0;
}
.dropdown-main-container.open {
  display: flex;
}

.dropdown-wrapper {
  width: 320px;
}

/* Main dropdown styling */
.searchable-dropdown-container {
  background-color: #ffffff;
  border-radius: 12px;
  width: 100%;
  border: 1px solid #c9c9c9;
  box-shadow: 0px 8px 24px 0px rgba(28,28,28,0.15);
  position: relative;
}

.dropdown-content {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: 400px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #c9c9c9 transparent;
}

/* Search section flexbox layout */
.search-section {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px;
}

.search-input-container {
  background-color: #ffffff;
  height: 48px;
  border-radius: 16px;
  border: 1px solid #ccdce4;
  position: relative;
}

.search-input-wrapper {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 4px 12px;
}

.search-icon-container {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.search-icon {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  padding-bottom: 16px;
}

.search-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: #525252;
  font-size: 16px;
  line-height: 1;
  padding-bottom: 8px;
}

.search-input::placeholder {
  color: #6b7280;
}

/* Selected label */
.selected-label {
  color: #005c98;
  font-size: 16px;
  line-height: 1;
}

/* Items container using flexbox */
.dropdown-items-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}

/* Individual dropdown items */
.dropdown-item {
  width: 100%;
  position: relative;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: #ffffff;
}

.dropdown-item.selected {
  background-color: #d9ecfa;
  .item-content {
    .item-check-container {
      .check-icon {
        display: block;
      }
    }
  }
}

.dropdown-item:hover:not(.selected) {
  background-color: #f9fafb;
}

/* Item border */
.dropdown-item::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 1px;
  background-color: #f3f4f6;
  pointer-events: none;
}

.dropdown-item:last-child::after {
  display: none;
}

/* Item content layout using flexbox */
.item-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 8px;
  position: relative;
  width: 100%;
  font-weight: 400;
  user-select: none;
}

.item-name-section {
  display: flex;
  align-items: center;
  gap: 8px;
}

.item-name-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.item-name-text {
  color: #525252;
  white-space: nowrap;
  font-size: 16px;
  line-height: 1;
}

.item-check-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  height: 32px;
}

.check-icon {
  width: 16px;
  height: 16px;
  display: none;
  padding-bottom: 24px;
  padding-right: 12px;
}

/* Responsive design */
@media (max-width: 640px) {
  .dropdown-wrapper {
    width: 100%;
    max-width: 320px;
  }
  
  .dropdown-main-container {
    padding: 1rem;
  }
}

/* Focus states for accessibility */
.search-input:focus {
  outline: 2px solid #005D98;
  outline-offset: -1px;
  border: none;
  outline: none;
}

.dropdown-item:focus {
  outline: 2px solid #005D98;
  outline-offset: -1px;
}

/* Animation for smooth interactions */
.dropdown-item {
  transform: translateY(0);
  opacity: 1;
}

.dropdown-item.removing {
  opacity: 0;
  transform: translateY(-10px);
  transition: all 0.3s ease;
}

/* Loading state */
.dropdown-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  color: #6b7280;
  font-style: italic;
}

/* Empty state */
.dropdown-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  font-style: italic;
  font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/selectbox.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,YAAY;EACZ,yEAAyE;EACzE,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,qEAAqE;EACrE,iDAAiD;EACjD,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,oEAAoE;EACpE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,OAAO;AACT;AACA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,OAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB;IACE;MACE;QACE,cAAc;MAChB;IACF;EACF;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,mCAAmC;AACnC;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA,sCAAsC;AACtC;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[":host {\n  position: relative;\n  height: 48px;\n}\n\n.dropdown-textbox {\n  display: flex;\n  min-width: 240px;\n  height: 48px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: var(--Spacings-Spacing-01, 4px);\n}\n\n:host(.compact) .dropdown-textbox {\n  min-width: clamp(160px, 18vw, 240px);\n}\n.dropdown-textbox-content {\n  display: flex;\n  height: 40px;\n  padding: var(--Spacings-Spacing-01, 4px) var(--Spacings-Spacing-03, 12px);\n  justify-content: space-between;\n  align-items: center;\n  flex-shrink: 0;\n  align-self: stretch;\n  border-radius: 16px;\n  border: 1px solid var(--Colors-UI-Secondary-Secondary-Light, #CCDCE4);\n  background: var(--Colors-UI-Neutral-Grey-0, #FFF);\n  cursor: pointer;\n}\n.dropdown-textbox-content:hover {\n  background: #F0F4F8;\n}\n.dropdown-textbox-content:active {\n  background: #E0E8F0;\n}\n.dropdown-textbox-inner {\n  display: flex;\n  padding: 0 var(--Spacings-Spacing-02, 8px);\n  align-items: center;\n  justify-content: space-between;\n  flex: 1 0 0;\n  user-select: none;\n}\n.dropdown-textbox-title {\n  color: var(--Colors-UI-Status-Information-Information-Dark, #023650);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  white-space: nowrap;\n  user-select: none;\n}\n.dropdown-textbox-title.placeholder {\n  font-weight: 400;\n}\n\n.dropdown-main-container {\n  z-index: 50;\n  display: none;\n  align-items: center;\n  justify-content: center;\n  background-color: #f9fafb;\n  position: absolute;\n  top: 100%;\n  left: 0;\n}\n.dropdown-main-container.open {\n  display: flex;\n}\n\n.dropdown-wrapper {\n  width: 320px;\n}\n\n/* Main dropdown styling */\n.searchable-dropdown-container {\n  background-color: #ffffff;\n  border-radius: 12px;\n  width: 100%;\n  border: 1px solid #c9c9c9;\n  box-shadow: 0px 8px 24px 0px rgba(28,28,28,0.15);\n  position: relative;\n}\n\n.dropdown-content {\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  max-height: 400px;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: #c9c9c9 transparent;\n}\n\n/* Search section flexbox layout */\n.search-section {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 12px;\n}\n\n.search-input-container {\n  background-color: #ffffff;\n  height: 48px;\n  border-radius: 16px;\n  border: 1px solid #ccdce4;\n  position: relative;\n}\n\n.search-input-wrapper {\n  display: flex;\n  align-items: center;\n  height: 100%;\n  padding: 4px 12px;\n}\n\n.search-icon-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n}\n\n.search-icon {\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  padding-bottom: 16px;\n}\n\n.search-input {\n  flex: 1;\n  background: transparent;\n  border: none;\n  outline: none;\n  color: #525252;\n  font-size: 16px;\n  line-height: 1;\n  padding-bottom: 8px;\n}\n\n.search-input::placeholder {\n  color: #6b7280;\n}\n\n/* Selected label */\n.selected-label {\n  color: #005c98;\n  font-size: 16px;\n  line-height: 1;\n}\n\n/* Items container using flexbox */\n.dropdown-items-container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n/* Individual dropdown items */\n.dropdown-item {\n  width: 100%;\n  position: relative;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background-color: #ffffff;\n}\n\n.dropdown-item.selected {\n  background-color: #d9ecfa;\n  .item-content {\n    .item-check-container {\n      .check-icon {\n        display: block;\n      }\n    }\n  }\n}\n\n.dropdown-item:hover:not(.selected) {\n  background-color: #f9fafb;\n}\n\n/* Item border */\n.dropdown-item::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background-color: #f3f4f6;\n  pointer-events: none;\n}\n\n.dropdown-item:last-child::after {\n  display: none;\n}\n\n/* Item content layout using flexbox */\n.item-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 4px 8px;\n  position: relative;\n  width: 100%;\n  font-weight: 400;\n  user-select: none;\n}\n\n.item-name-section {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.item-name-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.item-name-text {\n  color: #525252;\n  white-space: nowrap;\n  font-size: 16px;\n  line-height: 1;\n}\n\n.item-check-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px 8px;\n  height: 32px;\n}\n\n.check-icon {\n  width: 16px;\n  height: 16px;\n  display: none;\n  padding-bottom: 24px;\n  padding-right: 12px;\n}\n\n/* Responsive design */\n@media (max-width: 640px) {\n  .dropdown-wrapper {\n    width: 100%;\n    max-width: 320px;\n  }\n  \n  .dropdown-main-container {\n    padding: 1rem;\n  }\n}\n\n/* Focus states for accessibility */\n.search-input:focus {\n  outline: 2px solid #005D98;\n  outline-offset: -1px;\n  border: none;\n  outline: none;\n}\n\n.dropdown-item:focus {\n  outline: 2px solid #005D98;\n  outline-offset: -1px;\n}\n\n/* Animation for smooth interactions */\n.dropdown-item {\n  transform: translateY(0);\n  opacity: 1;\n}\n\n.dropdown-item.removing {\n  opacity: 0;\n  transform: translateY(-10px);\n  transition: all 0.3s ease;\n}\n\n/* Loading state */\n.dropdown-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  color: #6b7280;\n  font-style: italic;\n}\n\n/* Empty state */\n.dropdown-empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #6b7280;\n  font-style: italic;\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
